import { createActionCreator } from '@pressreader/appstore';
import { type ArticleFields, IArticle, IArticleUpdatable } from '@pressreader/content-types';
import { ArticleLoadingTags } from '@pressreader/feed-types';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/articles/`;

export const loadArticleBegan = createActionCreator<{
    articleId: string;
    loadingTags: ArticleLoadingTags[];
    requiredFields?: ArticleFields;
    loadId: string;
}>(`${prefix}load-article-began`);

export const loadArticleDone = createActionCreator<{
    article: IArticle;
    requiredFields?: ArticleFields;
}>(`${prefix}load-article-done`);

export const loadArticleFailed = createActionCreator<ArticleActionPayload & { loadId: string }>(`${prefix}load-article-failed`);

/**
 * An article load was cancelled mid-request: the `Pending` entry it marked is released when
 * `loadId` still owns the entry.
 */
export const loadArticleCancelled = createActionCreator<ArticleActionPayload & { loadId: string }>(`${prefix}load-article-cancelled`);

export const articlesLoaded = createActionCreator<{
    articles: IArticle[];
}>(`${prefix}articles-loaded`);

export const articleUpdated = createActionCreator<{
    articleId: string;
    article: IArticleUpdatable;
}>(`${prefix}article-updated`);

export type ArticlesUpdatedPayloadArticleUpdate = IArticleUpdatable & { articleId: string };

export const articlesUpdated = createActionCreator<{
    articleUpdates: Array<ArticlesUpdatedPayloadArticleUpdate>;
}>(`${prefix}articles-updated`);
